module.exports = __webpack_public_path__ + "static/img/shezhi_tuichu.4823cd74.png";